import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { colorsV2 } from '../../colors-v2';
import { DolAvatarImg } from '../../Avatar/DolAvatarImg';

const Badge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;

  border-radius: 50%;
  outline: 1px solid ${colorsV2.white100};
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;
  background-color: ${colorsV2.gray20};

  &.layout-badge {
    position: relative;
  }

  &.as-inline {
    display: inline-flex;
    justify-content: center;
  }
`;

const USER_AVATAR_TYPE = {
  DEFAULT: 'default',
  STATUS_DOT: 'status-dot',
  ICON: 'icon',
  BADGE: 'badge',
} as const;

export interface UserAvatarProps {
  layout?: (typeof USER_AVATAR_TYPE)[keyof typeof USER_AVATAR_TYPE];
  className?: string;
  size?: number;
  userAvatar?: any;
  userName?: string;
  badgeContent?: React.ReactNode;

  onClick?: () => void;
  inline?: boolean;
}

export const UserAvatar = (props: UserAvatarProps) => {
  const { layout = USER_AVATAR_TYPE.DEFAULT, inline, className, size, userAvatar, userName, badgeContent, onClick } = props;

  return (
    <Container className={cl('user-avatar', className, `layout-${layout}`, { 'as-inline': inline })} onClick={onClick}>
      <DolAvatarImg
        className="user-avatar-image"
        size={`${size}px`}
        name={userName}
        textSizeRatio={1.75}
        round
        url={userAvatar?.url || userAvatar}
        style={{ objectFit: 'cover' }}
      />
      {USER_AVATAR_TYPE.BADGE === layout && <Badge>{badgeContent}</Badge>}
    </Container>
  );
};
